import { configureStore } from '@reduxjs/toolkit';
import demoSlice from './demo/demoSlice';
import portalSlice from './portal/portalSlice';
import userSlice from './user/userSlice';
import eventSlice from './events/eventSlice';
import myEventSlice from './myEvents/myEventSlice';
import myFavoriteSlice from './myFavorites/myFavoritesSlice';

const rootReducer = {
  demo: demoSlice.reducer,
  portal: portalSlice.reducer,
  user: userSlice.reducer,
  event: eventSlice.reducer,
  myEvent: myEventSlice.reducer,
  myFavorites: myFavoriteSlice.reducer,
};

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
